import { createContext, useContext } from 'react';
const NotificationManagerContext = createContext(null);
export const NotificationManagerProviderConsumer = NotificationManagerContext.Consumer;
export function useNotificationManager() {
    return useContext(NotificationManagerContext);
}
export { NotificationManagerContext };
//# sourceMappingURL=NotificationManagerContext.js.map